"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t7 in e) "default" !== _t7 && {}.hasOwnProperty.call(e, _t7) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t7)) && (i.get || i.set) ? o(f, _t7, i) : f[_t7] = e[_t7]); return f; })(e, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
var _default2 = exports.default = {
  name: 'TencentMap',
  props: {
    // 地图容器高度
    mapHeight: {
      type: String,
      default: '300px'
    },
    // 初始中心点坐标
    center: {
      type: Object,
      default: function _default() {
        return {
          lat: 39.908823,
          lng: 116.397470
        };
      }
    },
    // 初始缩放级别
    zoom: {
      type: Number,
      default: 13
    },
    // 是否显示控件
    showControls: {
      type: Boolean,
      default: true
    },
    // 是否显示搜索按钮
    showSearchButton: {
      type: Boolean,
      default: true
    },
    // 是否显示提示信息
    showTips: {
      type: Boolean,
      default: true
    },
    // 提示文本
    tips: {
      type: String,
      default: '提示：点击地图或拖拽标记点来选择位置'
    },
    // 是否显示位置信息
    showLocationInfo: {
      type: Boolean,
      default: true
    },
    // 是否显示API Key
    showApiKey: {
      type: Boolean,
      default: false
    },
    // 布局模式：vertical 为上下布局，pc 为左右工作台布局
    layout: {
      type: String,
      default: 'vertical'
    },
    // 初始位置值
    value: {
      type: Object,
      default: function _default() {
        return null;
      }
    }
  },
  data: function data() {
    return {
      // 地图相关
      mapContainerId: "map-container-".concat(Date.now(), "-").concat(Math.random().toString(36).substr(2, 9)),
      map: null,
      marker: null,
      geolocation: null,
      mapType: null,
      // 'TMap' 或 'qq.maps'

      // 位置相关
      locationLoading: false,
      locationInfo: null,
      // 搜索相关
      searchKeyword: '',
      searchLoading: false,
      searchResults: [],
      showSearchResults: false,
      // 初始化相关
      initRetryCount: 0,
      maxInitRetries: 10,
      isInitializing: false,
      // 定位重试相关
      locationRetryCount: 0
    };
  },
  mounted: function mounted() {
    var _this = this;
    // 显示调试信息
    this.showDebugInfo();

    // 延迟初始化，避免频繁切换时的冲突
    this.$nextTick(function () {
      _this.initializeMap();
      // 如果有初始值，设置位置信息
      if (_this.value) {
        _this.locationInfo = _this.value;
      }
    });
  },
  beforeDestroy: function beforeDestroy() {
    this.destroyMap();
  },
  watch: {
    // 监听value属性变化，响应式更新地图位置
    value: {
      handler: function handler(newValue) {
        if (newValue && newValue.lat && newValue.lng) {
          // 更新locationInfo以显示位置信息
          this.locationInfo = {
            lat: newValue.lat,
            lng: newValue.lng,
            addr: newValue.address || newValue.addr || '',
            accuracy: newValue.accuracy || 0
          };

          // 如果地图已初始化，更新地图位置
          if (this.map) {
            this.updateMapLocation(newValue.lat, newValue.lng);
          }
        }
      },
      deep: true,
      immediate: false
    }
  },
  methods: {
    // ==================== API Key 相关 ====================
    /**
     * 获取当前API Key
     * 从store中获取腾讯地图API Key
     */
    getCurrentApiKey: function getCurrentApiKey() {
      return this.$store.state.settings.tencentMapKey || 'YOUR_TENCENT_MAP_API_KEY';
    },
    /**
     * 复制API Key到剪贴板
     */
    copyApiKey: function copyApiKey() {
      var _this2 = this;
      var apiKey = this.getCurrentApiKey();
      if (navigator.clipboard) {
        navigator.clipboard.writeText(apiKey).then(function () {
          _this2.$message.success('API Key已复制到剪贴板');
        }).catch(function () {
          _this2.$message.error('复制失败，请手动复制');
        });
      } else {
        // 兼容旧浏览器
        var textArea = document.createElement('textarea');
        textArea.value = apiKey;
        document.body.appendChild(textArea);
        textArea.select();
        try {
          document.execCommand('copy');
          this.$message.success('API Key已复制到剪贴板');
        } catch (err) {
          this.$message.error('复制失败，请手动复制');
        }
        document.body.removeChild(textArea);
      }
    },
    /**
     * 重新获取API Key
     */
    retryGetApiKey: function () {
      var _retryGetApiKey = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var _yield$import, getTencentMapKeyApi, res, apiKey, _t;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.p = _context.n) {
            case 0:
              _context.p = 0;
              if (!(this.$parent && typeof this.$parent.getTencentMapKey === 'function')) {
                _context.n = 2;
                break;
              }
              _context.n = 1;
              return this.$parent.getTencentMapKey();
            case 1:
              return _context.a(2);
            case 2:
              if (!(this.$root && typeof this.$root.getTencentMapKey === 'function')) {
                _context.n = 4;
                break;
              }
              _context.n = 3;
              return this.$root.getTencentMapKey();
            case 3:
              return _context.a(2);
            case 4:
              _context.n = 5;
              return Promise.resolve().then(function () {
                return _interopRequireWildcard(require('@/api/systemConfig'));
              });
            case 5:
              _yield$import = _context.v;
              getTencentMapKeyApi = _yield$import.getTencentMapKeyApi;
              _context.n = 6;
              return getTencentMapKeyApi();
            case 6:
              res = _context.v;
              if (!res) {
                _context.n = 8;
                break;
              }
              // 处理字符串或对象格式的响应
              apiKey = typeof res === 'string' ? res : res.value || res.data || res;
              if (!apiKey) {
                _context.n = 7;
                break;
              }
              this.$store.commit('settings/SET_tencentMapKey', apiKey);
              return _context.a(2, apiKey);
            case 7:
              _context.n = 9;
              break;
            case 8:
              throw new Error('API返回的数据格式不正确');
            case 9:
              _context.n = 11;
              break;
            case 10:
              _context.p = 10;
              _t = _context.v;
              console.error('重新获取API Key失败:', _t);
              throw _t;
            case 11:
              return _context.a(2);
          }
        }, _callee, this, [[0, 10]]);
      }));
      function retryGetApiKey() {
        return _retryGetApiKey.apply(this, arguments);
      }
      return retryGetApiKey;
    }(),
    // ==================== 地图初始化 ====================
    /**
     * 初始化地图
     */
    initializeMap: function () {
      var _initializeMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var container, _t2;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.p = _context2.n) {
            case 0:
              if (!(this.isInitializing || this.map)) {
                _context2.n = 1;
                break;
              }
              return _context2.a(2);
            case 1:
              this.isInitializing = true;
              this.initRetryCount = 0;
              _context2.p = 2;
              // 检查容器是否存在
              container = document.getElementById(this.mapContainerId);
              if (container) {
                _context2.n = 3;
                break;
              }
              throw new Error('地图容器未找到，可能组件已被销毁');
            case 3:
              if (!(container.offsetWidth === 0 || container.offsetHeight === 0)) {
                _context2.n = 4;
                break;
              }
              console.warn('地图容器尺寸为0，等待容器准备就绪...');
              _context2.n = 4;
              return this.waitForContainer(container);
            case 4:
              _context2.n = 5;
              return this.loadMapAPI();
            case 5:
              _context2.n = 6;
              return this.createMap();
            case 6:
              // 地图初始化成功后，如果有初始值，延迟设置位置
              if (this.value && this.value.lat && this.value.lng) {
                setTimeout(function () {
                  _this3.updateMapLocation(_this3.value.lat, _this3.value.lng);
                }, 300);
              }
              this.$emit('map-ready', this.map);
              _context2.n = 8;
              break;
            case 7:
              _context2.p = 7;
              _t2 = _context2.v;
              console.error('地图初始化失败:', _t2);
              // 只有在组件未被销毁时才发送错误事件
              if (!this._isDestroyed) {
                this.$emit('map-error', _t2);
              }
            case 8:
              _context2.p = 8;
              this.isInitializing = false;
              return _context2.f(8);
            case 9:
              return _context2.a(2);
          }
        }, _callee2, this, [[2, 7, 8, 9]]);
      }));
      function initializeMap() {
        return _initializeMap.apply(this, arguments);
      }
      return initializeMap;
    }(),
    /**
     * 加载地图API
     */
    loadMapAPI: function () {
      var _loadMapAPI = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3() {
        var apiKey, newApiKey;
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              if (!(window.TMap || window.qq)) {
                _context3.n = 1;
                break;
              }
              return _context3.a(2);
            case 1:
              apiKey = this.getCurrentApiKey(); // 如果API Key无效，尝试重新获取
              if (!(!apiKey || apiKey === 'YOUR_TENCENT_MAP_API_KEY')) {
                _context3.n = 3;
                break;
              }
              console.warn('腾讯地图API Key未配置，尝试重新获取...');
              _context3.n = 2;
              return this.retryGetApiKey();
            case 2:
              newApiKey = this.getCurrentApiKey();
              if (!(!newApiKey || newApiKey === 'YOUR_TENCENT_MAP_API_KEY')) {
                _context3.n = 3;
                break;
              }
              throw new Error('腾讯地图API Key获取失败');
            case 3:
              _context3.n = 4;
              return this.loadMapScripts(this.getCurrentApiKey());
            case 4:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function loadMapAPI() {
        return _loadMapAPI.apply(this, arguments);
      }
      return loadMapAPI;
    }(),
    /**
     * 动态加载地图脚本
     */
    loadMapScripts: function loadMapScripts(apiKey) {
      return new Promise(function (resolve, reject) {
        var scripts = ["https://map.qq.com/api/gljs?v=1.exp&key=".concat(apiKey, "&libraries=service"), "https://apis.map.qq.com/tools/geolocation/min?key=".concat(apiKey, "&referer=myapp"), "https://map.qq.com/api/js?v=2.exp&key=".concat(apiKey)];
        var loadedCount = 0;
        var totalScripts = scripts.length;
        scripts.forEach(function (src) {
          var script = document.createElement('script');
          script.charset = 'utf-8';
          script.src = src;
          script.onload = function () {
            loadedCount++;
            if (loadedCount === totalScripts) {
              console.log('腾讯地图API脚本加载完成');
              resolve();
            }
          };
          script.onerror = function () {
            reject(new Error("\u817E\u8BAF\u5730\u56FEAPI\u811A\u672C\u52A0\u8F7D\u5931\u8D25: ".concat(src)));
          };
          document.head.appendChild(script);
        });
      });
    },
    /**
     * 创建地图实例
     */
    createMap: function () {
      var _createMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee4() {
        var mapContainer;
        return _regenerator().w(function (_context4) {
          while (1) switch (_context4.n) {
            case 0:
              _context4.n = 1;
              return this.waitForMapAPI();
            case 1:
              mapContainer = document.getElementById(this.mapContainerId);
              if (mapContainer) {
                _context4.n = 2;
                break;
              }
              throw new Error('地图容器未找到');
            case 2:
              if (!(window.TMap && window.TMap.Map)) {
                _context4.n = 3;
                break;
              }
              this.mapType = 'TMap';
              this.createTMap(mapContainer);
              _context4.n = 5;
              break;
            case 3:
              if (!(window.qq && window.qq.maps && window.qq.maps.Map)) {
                _context4.n = 4;
                break;
              }
              this.mapType = 'qq.maps';
              this.createQQMap(mapContainer);
              _context4.n = 5;
              break;
            case 4:
              throw new Error('腾讯地图API未正确加载');
            case 5:
              // 初始化位置
              if (this.value && this.value.lat && this.value.lng) {
                this.updateMapLocation(this.value.lat, this.value.lng);
              }
            case 6:
              return _context4.a(2);
          }
        }, _callee4, this);
      }));
      function createMap() {
        return _createMap.apply(this, arguments);
      }
      return createMap;
    }(),
    /**
     * 等待容器准备就绪
     */
    waitForContainer: function waitForContainer(container) {
      return new Promise(function (resolve, reject) {
        var retryCount = 0;
        var maxRetries = 20;
        var _checkContainer = function checkContainer() {
          retryCount++;
          if (container.offsetWidth > 0 && container.offsetHeight > 0) {
            resolve();
            return;
          }
          if (retryCount < maxRetries) {
            console.warn("\u7B49\u5F85\u5730\u56FE\u5BB9\u5668\u51C6\u5907\u5C31\u7EEA... (".concat(retryCount, "/").concat(maxRetries, ")"));
            setTimeout(_checkContainer, 100);
          } else {
            reject(new Error('地图容器准备超时'));
          }
        };
        setTimeout(_checkContainer, 50);
      });
    },
    /**
     * 等待地图API加载完成
     */
    waitForMapAPI: function waitForMapAPI() {
      var _this4 = this;
      return new Promise(function (resolve, reject) {
        var _checkAPI = function checkAPI() {
          _this4.initRetryCount++;
          if (window.TMap && window.TMap.Map) {
            resolve();
            return;
          }
          if (window.qq && window.qq.maps && window.qq.maps.Map) {
            resolve();
            return;
          }
          if (_this4.initRetryCount < _this4.maxInitRetries) {
            console.warn("\u7B49\u5F85\u817E\u8BAF\u5730\u56FEAPI\u52A0\u8F7D... (".concat(_this4.initRetryCount, "/").concat(_this4.maxInitRetries, ")"));
            setTimeout(_checkAPI, 2000);
          } else {
            reject(new Error('腾讯地图API加载超时'));
          }
        };
        setTimeout(_checkAPI, 1000);
      });
    },
    /**
     * 创建TMap地图
     */
    createTMap: function createTMap(container) {
      var _this5 = this;
      // 创建地图实例
      this.map = new window.TMap.Map(container, {
        center: new window.TMap.LatLng(this.center.lat, this.center.lng),
        zoom: this.zoom
      });

      // 创建标记点
      this.marker = new window.TMap.MultiMarker({
        id: 'marker-layer',
        map: this.map,
        enableDragging: true,
        styles: {
          'default': new window.TMap.MarkerStyle({
            width: 25,
            height: 35,
            anchor: {
              x: 12,
              y: 35
            }
          })
        },
        geometries: [{
          id: 'marker1',
          styleId: 'default',
          position: new window.TMap.LatLng(this.center.lat, this.center.lng),
          draggable: true,
          properties: {
            title: '当前位置'
          }
        }]
      });

      // 绑定事件
      this.map.on('click', function (evt) {
        return _this5.onMapClick(evt.latLng);
      });
      this.marker.on('dragend', function (evt) {
        return _this5.onMarkerDragEnd(evt.latLng);
      });

      // 初始化定位服务
      this.initGeolocationService();
    },
    /**
     * 创建qq.maps地图
     */
    createQQMap: function createQQMap(container) {
      var _this6 = this;
      // 创建地图实例
      this.map = new window.qq.maps.Map(container, {
        center: new window.qq.maps.LatLng(this.center.lat, this.center.lng),
        zoom: this.zoom
      });

      // 创建标记点
      this.marker = new window.qq.maps.Marker({
        map: this.map,
        position: new window.qq.maps.LatLng(this.center.lat, this.center.lng),
        draggable: true
      });

      // 绑定事件
      window.qq.maps.event.addListener(this.map, 'click', function (evt) {
        return _this6.onMapClick(evt.latLng);
      });
      window.qq.maps.event.addListener(this.marker, 'dragend', function (evt) {
        return _this6.onMarkerDragEnd(evt.latLng);
      });

      // 初始化定位服务
      this.initGeolocationService();
    },
    /**
     * 初始化定位服务
     */
    initGeolocationService: function initGeolocationService() {
      try {
        if (window.qq && window.qq.maps && window.qq.maps.Geolocation) {
          var apiKey = this.getCurrentApiKey();

          // 检查API Key是否有效
          if (!apiKey || apiKey === 'YOUR_TENCENT_MAP_API_KEY') {
            console.warn('腾讯地图API Key未配置或无效，定位服务可能无法正常工作');
            return;
          }

          // 初始化定位服务
          this.geolocation = new window.qq.maps.Geolocation(apiKey, 'myapp');
          console.log('腾讯定位服务初始化成功');
        } else {
          console.warn('腾讯地图定位API未加载，将使用浏览器原生定位');
        }
      } catch (error) {
        console.error('初始化腾讯定位服务失败:', error);
      }
    },
    /**
     * 销毁地图
     */
    destroyMap: function destroyMap() {
      try {
        // 停止正在进行的初始化
        this.isInitializing = false;

        // 清理地图实例
        if (this.map) {
          if (this.map.destroy) {
            this.map.destroy();
          } else if (this.map.remove) {
            this.map.remove();
          }
        }

        // 清理所有引用
        this.map = null;
        this.marker = null;
        this.geolocation = null;
        this.locationInfo = null;
        this.searchResults = [];
      } catch (error) {
        console.warn('地图销毁时出现警告:', error);
      }
    },
    // ==================== 地图交互 ====================
    /**
     * 地图点击事件
     */
    onMapClick: function onMapClick(latLng) {
      this.updateMarkerPosition(latLng);
    },
    /**
     * 标记拖拽结束事件
     */
    onMarkerDragEnd: function onMarkerDragEnd(latLng) {
      this.updateMarkerPosition(latLng);
    },
    /**
     * 更新标记位置
     */
    updateMarkerPosition: function updateMarkerPosition(latLng) {
      var lat = latLng.lat || latLng.getLat();
      var lng = latLng.lng || latLng.getLng();

      // 更新标记位置
      if (this.mapType === 'TMap' && this.marker) {
        this.marker.updateGeometries([{
          id: 'marker1',
          styleId: 'default',
          position: latLng,
          draggable: true,
          properties: {
            title: '当前位置'
          }
        }]);
      } else if (this.mapType === 'qq.maps' && this.marker) {
        this.marker.setPosition(latLng);
      }

      // 更新地图中心
      if (this.map) {
        this.map.setCenter(latLng);
      }

      // 获取地址信息
      this.reverseGeocode(lat, lng);
    },
    /**
     * 更新地图位置
     */
    updateMapLocation: function updateMapLocation(lat, lng) {
      var _this7 = this;
      if (!this.map || !this.marker) {
        console.warn('地图或标记未初始化，延迟更新位置');
        // 如果地图未初始化，延迟执行
        setTimeout(function () {
          if (_this7.map && _this7.marker) {
            _this7.updateMapLocation(lat, lng);
          }
        }, 500);
        return;
      }

      // 验证坐标有效性
      if (!this.isValidCoordinate(lat, lng)) {
        console.error('无效的坐标值:', {
          lat: lat,
          lng: lng
        });
        return;
      }
      try {
        var numLat = parseFloat(lat);
        var numLng = parseFloat(lng);
        var latLng = this.mapType === 'TMap' ? new window.TMap.LatLng(numLat, numLng) : new window.qq.maps.LatLng(numLat, numLng);

        // 先更新标记位置，再更新地图中心
        if (this.mapType === 'TMap') {
          this.marker.updateGeometries([{
            id: 'marker1',
            styleId: 'default',
            position: latLng,
            draggable: true,
            properties: {
              title: '当前位置'
            }
          }]);
        } else {
          this.marker.setPosition(latLng);
        }

        // 延迟更新地图中心，避免地图API内部冲突
        this.$nextTick(function () {
          if (_this7.map) {
            _this7.map.setCenter(latLng);
          }
        });
      } catch (error) {
        console.error('更新地图位置失败:', error);
        // 如果更新失败，尝试重新初始化地图
        if (error.message && error.message.includes('far')) {
          console.warn('检测到地图距离计算错误，尝试重新初始化');
          this.reinitializeMap();
        }
      }
    },
    /**
     * 重置地图中心
     */
    resetMapCenter: function resetMapCenter() {
      this.updateMapLocation(this.center.lat, this.center.lng);
      if (this.map) {
        this.map.setZoom(this.zoom);
      }
    },
    /**
     * 验证坐标有效性
     */
    isValidCoordinate: function isValidCoordinate(lat, lng) {
      // 检查坐标是否为数字
      var numLat = parseFloat(lat);
      var numLng = parseFloat(lng);
      if (isNaN(numLat) || isNaN(numLng)) {
        return false;
      }

      // 检查纬度范围 (-90 到 90)
      if (numLat < -90 || numLat > 90) {
        return false;
      }

      // 检查经度范围 (-180 到 180)
      if (numLng < -180 || numLng > 180) {
        return false;
      }
      return true;
    },
    /**
     * 重新初始化地图
     */
    reinitializeMap: function () {
      var _reinitializeMap = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee5() {
        var _t3;
        return _regenerator().w(function (_context5) {
          while (1) switch (_context5.p = _context5.n) {
            case 0:
              console.log('开始重新初始化地图...');

              // 先销毁现有地图
              this.destroyMap();

              // 等待一段时间后重新初始化
              _context5.n = 1;
              return new Promise(function (resolve) {
                return setTimeout(resolve, 1000);
              });
            case 1:
              _context5.p = 1;
              _context5.n = 2;
              return this.initializeMap();
            case 2:
              _context5.n = 4;
              break;
            case 3:
              _context5.p = 3;
              _t3 = _context5.v;
              console.error('地图重新初始化失败:', _t3);
              this.$emit('map-error', _t3);
            case 4:
              return _context5.a(2);
          }
        }, _callee5, this, [[1, 3]]);
      }));
      function reinitializeMap() {
        return _reinitializeMap.apply(this, arguments);
      }
      return reinitializeMap;
    }(),
    // ==================== 定位功能 ====================
    /**
     * 获取当前位置
     */
    getCurrentLocation: function getCurrentLocation() {
      this.locationLoading = true;
      this.locationInfo = null;
      this.locationRetryCount = 0; // 重置重试计数

      // 优先使用腾讯位置服务
      if (this.geolocation) {
        this.getTencentLocation();
      } else {
        this.getBrowserLocation();
      }
    },
    /**
     * 重试定位
     */
    retryLocation: function retryLocation() {
      var _this8 = this;
      if (this.locationRetryCount < 2) {
        // 最多重试2次
        this.locationRetryCount++;
        setTimeout(function () {
          _this8.getCurrentLocation();
        }, 2000); // 2秒后重试
      } else {
        this.locationLoading = false;
        this.$message.error('定位服务暂时不可用，请稍后重试或手动选择位置');
      }
    },
    /**
     * 检查网络连接状态
     */
    checkNetworkStatus: function checkNetworkStatus() {
      if (navigator.onLine === false) {
        console.warn('网络连接不可用');
        return false;
      }

      // 检查腾讯地图API的可达性
      return fetch('https://apis.map.qq.com/ws/geocoder/v1/', {
        method: 'HEAD',
        mode: 'no-cors',
        cache: 'no-cache'
      }).then(function () {
        return true;
      }).catch(function (error) {
        console.warn('腾讯地图API网络连接异常:', error);
        return false;
      });
    },
    /**
     * 显示调试信息
     */
    showDebugInfo: function showDebugInfo() {
      var debugInfo = {
        '浏览器信息': navigator.userAgent,
        '协议': location.protocol,
        '域名': location.hostname,
        '网络状态': navigator.onLine ? '在线' : '离线',
        'API Key': this.getCurrentApiKey(),
        '腾讯地图API': window.qq && window.qq.maps ? '已加载' : '未加载',
        '定位服务': this.geolocation ? '已初始化' : '未初始化',
        'HTTPS支持': location.protocol === 'https:' ? '是' : '否'
      };
      console.group('腾讯地图调试信息');
      Object.entries(debugInfo).forEach(function (_ref) {
        var _ref2 = _slicedToArray(_ref, 2),
          key = _ref2[0],
          value = _ref2[1];
        console.log("".concat(key, ": ").concat(value));
      });
      console.groupEnd();
      return debugInfo;
    },
    /**
     * 使用腾讯位置服务定位
     */
    getTencentLocation: function getTencentLocation() {
      var _this9 = this;
      // 检查定位服务是否可用
      if (!this.geolocation) {
        console.warn('腾讯定位服务未初始化，使用浏览器定位');
        this.getBrowserLocation();
        return;
      }

      // 设置超时处理
      var timeoutId = setTimeout(function () {
        console.warn('腾讯位置服务超时，切换到浏览器定位');
        _this9.getBrowserLocation();
      }, 8000); // 8秒超时

      this.geolocation.getLocation(function (position) {
        clearTimeout(timeoutId);
        var lat = position.lat,
          lng = position.lng,
          accuracy = position.accuracy,
          addr = position.addr;
        _this9.locationInfo = {
          lat: lat,
          lng: lng,
          accuracy: accuracy || 0,
          addr: addr || ''
        };
        _this9.updateMapLocation(lat, lng);
        _this9.$emit('location-change', {
          lat: lat.toString(),
          lng: lng.toString(),
          address: addr || '',
          locationInfo: _this9.locationInfo
        });
        _this9.locationLoading = false;
        _this9.$message.success('定位成功');
      }, function (error) {
        clearTimeout(timeoutId);
        console.error('腾讯位置服务定位失败:', error);

        // 根据错误类型提供更详细的处理
        if (error.code === 5) {
          console.warn('腾讯位置服务API超时，可能是网络问题或API限制');
          // 检查网络状态
          _this9.checkNetworkStatus().then(function (isOnline) {
            if (!isOnline) {
              console.warn('网络连接异常，这可能是导致API超时的原因');
            }
          });
        } else if (error.code === 1) {
          console.warn('用户拒绝了定位请求');
        } else if (error.code === 2) {
          console.warn('位置信息不可用');
        } else if (error.code === 3) {
          console.warn('定位请求超时');
        }

        // 自动降级到浏览器定位
        console.log('腾讯定位失败，尝试浏览器定位');
        _this9.getBrowserLocation();
      }, {
        timeout: 6000,
        // 减少超时时间到6秒
        enableHighAccuracy: true
      });
    },
    /**
     * 使用浏览器原生定位
     */
    getBrowserLocation: function getBrowserLocation() {
      var _this0 = this;
      if (!navigator.geolocation) {
        this.locationLoading = false;
        this.$message.error('浏览器不支持定位功能');
        return;
      }

      // 检查是否为HTTPS环境
      if (location.protocol !== 'https:' && location.hostname !== 'localhost' && location.hostname !== '127.0.0.1') {
        console.warn('浏览器定位在非HTTPS环境下可能受限');
      }
      navigator.geolocation.getCurrentPosition(function (position) {
        var _position$coords = position.coords,
          lat = _position$coords.latitude,
          lng = _position$coords.longitude,
          accuracy = _position$coords.accuracy;
        _this0.locationInfo = {
          lat: lat,
          lng: lng,
          accuracy: accuracy || 0,
          addr: ''
        };
        _this0.updateMapLocation(lat, lng);
        _this0.reverseGeocode(lat, lng);
        _this0.locationLoading = false;
        _this0.$message.success('定位成功');
      }, function (error) {
        _this0.locationLoading = false;

        // 详细的错误处理
        var errorMessage = '定位失败';
        switch (error.code) {
          case error.PERMISSION_DENIED:
            errorMessage = '用户拒绝了定位请求，请在浏览器设置中允许定位权限';
            break;
          case error.POSITION_UNAVAILABLE:
            errorMessage = '位置信息不可用，请检查网络连接或GPS设置';
            break;
          case error.TIMEOUT:
            errorMessage = '定位请求超时，请重试';
            break;
          default:
            errorMessage = "\u5B9A\u4F4D\u5931\u8D25: ".concat(error.message);
            break;
        }
        console.error('浏览器定位失败:', error);

        // 如果是首次失败，尝试重试
        if (_this0.locationRetryCount === 0) {
          _this0.$message.warning('定位失败，正在重试...');
          _this0.retryLocation();
        } else {
          _this0.$message.error(errorMessage);
        }
      }, {
        timeout: 10000,
        enableHighAccuracy: true
      });
    },
    /**
     * 获取定位错误信息
     */
    getLocationErrorMessage: function getLocationErrorMessage(code) {
      var messages = {
        1: '用户拒绝了定位请求',
        2: '位置信息不可用',
        3: '定位超时'
      };
      return messages[code] || '未知错误';
    },
    // ==================== 地址解析 ====================
    getCoordinateValue: function getCoordinateValue(location, key, getter) {
      if (!location) return null;
      if (typeof location[getter] === 'function') return location[getter]();
      var value = location[key];
      return value === undefined || value === null ? null : Number(value);
    },
    getTMapLatLng: function getTMapLatLng(lat, lng) {
      if (!window.TMap || !window.TMap.LatLng) return null;
      return new window.TMap.LatLng(Number(lat), Number(lng));
    },
    getQQMapsLatLng: function getQQMapsLatLng(lat, lng) {
      if (!window.qq || !window.qq.maps || !window.qq.maps.LatLng) return null;
      return new window.qq.maps.LatLng(Number(lat), Number(lng));
    },
    getGeocoderAddress: function getGeocoderAddress(result) {
      var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
      var detail = result && (result.result || result.detail) || {};
      var formattedAddresses = detail.formatted_addresses || detail.formattedAddresses || {};
      return formattedAddresses.recommend || detail.address || fallback;
    },
    parseCoordinateKeyword: function parseCoordinateKeyword(keyword) {
      var text = (keyword || '').trim();
      var match = text.match(/^\s*([+-]?(?:\d+(?:\.\d+)?|\.\d+))\s*[,，\s]\s*([+-]?(?:\d+(?:\.\d+)?|\.\d+))\s*$/);
      if (!match) return null;
      var lat = Number(match[1]);
      var lng = Number(match[2]);
      var isValid = this.isValidCoordinate ? this.isValidCoordinate(lat, lng) : !Number.isNaN(lat) && !Number.isNaN(lng) && lat >= -90 && lat <= 90 && lng >= -180 && lng <= 180;
      return isValid ? {
        lat: lat,
        lng: lng
      } : null;
    },
    applyLocationChange: function applyLocationChange(lat, lng, address) {
      var accuracy = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 0;
      this.locationInfo = {
        lat: lat,
        lng: lng,
        accuracy: accuracy,
        addr: address
      };
      this.$emit('location-change', {
        lat: lat.toString(),
        lng: lng.toString(),
        address: address,
        locationInfo: this.locationInfo
      });
    },
    reverseGeocodeBySdk: function reverseGeocodeBySdk(lat, lng) {
      var _this1 = this;
      return new Promise(function (resolve, reject) {
        if (_this1.mapType === 'TMap') {
          if (!window.TMap || !window.TMap.service || !window.TMap.service.Geocoder) {
            reject(new Error('腾讯地图GL Geocoder未加载'));
            return;
          }
          var _latLng = _this1.getTMapLatLng(lat, lng);
          if (!_latLng) {
            reject(new Error('腾讯地图GL坐标对象创建失败'));
            return;
          }
          var _geocoder = new window.TMap.service.Geocoder();
          _geocoder.getAddress({
            location: _latLng
          }).then(function (result) {
            var _this1$locationInfo;
            var address = _this1.getGeocoderAddress(result);
            _this1.applyLocationChange(lat, lng, address, ((_this1$locationInfo = _this1.locationInfo) === null || _this1$locationInfo === void 0 ? void 0 : _this1$locationInfo.accuracy) || 0);
            resolve(address);
          }).catch(reject);
          return;
        }
        if (!window.qq || !window.qq.maps || !window.qq.maps.Geocoder) {
          reject(new Error('腾讯地图Geocoder未加载'));
          return;
        }
        var latLng = _this1.getQQMapsLatLng(lat, lng);
        if (!latLng) {
          reject(new Error('腾讯地图坐标对象创建失败'));
          return;
        }
        var geocoder = new window.qq.maps.Geocoder({
          complete: function complete(result) {
            var _this1$locationInfo2;
            var address = _this1.getGeocoderAddress(result);
            _this1.applyLocationChange(lat, lng, address, ((_this1$locationInfo2 = _this1.locationInfo) === null || _this1$locationInfo2 === void 0 ? void 0 : _this1$locationInfo2.accuracy) || 0);
            resolve(address);
          },
          error: reject
        });
        geocoder.getAddress(latLng);
      });
    },
    /**
     * 逆地址解析：只使用已加载的腾讯地图 JS SDK，避免浏览器直连 WebService 触发 CORS。
     */
    reverseGeocode: function () {
      var _reverseGeocode = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee6(lat, lng) {
        var _t4;
        return _regenerator().w(function (_context6) {
          while (1) switch (_context6.p = _context6.n) {
            case 0:
              _context6.p = 0;
              _context6.n = 1;
              return this.reverseGeocodeBySdk(lat, lng);
            case 1:
              _context6.n = 3;
              break;
            case 2:
              _context6.p = 2;
              _t4 = _context6.v;
              console.error('逆地址解析请求失败:', _t4);
            case 3:
              return _context6.a(2);
          }
        }, _callee6, this, [[0, 2]]);
      }));
      function reverseGeocode(_x, _x2) {
        return _reverseGeocode.apply(this, arguments);
      }
      return reverseGeocode;
    }(),
    // ==================== 地址搜索 ====================
    searchAddressByTMapGeocoder: function searchAddressByTMapGeocoder(keyword) {
      var _this10 = this;
      if (!window.TMap || !window.TMap.service || !window.TMap.service.Geocoder) {
        return Promise.reject(new Error('腾讯地图GL Geocoder未加载'));
      }
      var geocoder = new window.TMap.service.Geocoder();
      return geocoder.getLocation({
        address: keyword
      }).then(function (result) {
        var detail = result && result.result || {};
        var location = detail.location;
        var lat = _this10.getCoordinateValue(location, 'lat', 'getLat');
        var lng = _this10.getCoordinateValue(location, 'lng', 'getLng');
        if (lat === null || lng === null) {
          return [];
        }
        return [{
          title: keyword,
          address: _this10.getGeocoderAddress(result, keyword),
          lat: lat,
          lng: lng
        }];
      });
    },
    searchAddressBySdk: function searchAddressBySdk(keyword) {
      return new Promise(function (resolve, reject) {
        if (!window.qq || !window.qq.maps || !window.qq.maps.SearchService) {
          reject(new Error('腾讯地图SearchService未加载'));
          return;
        }
        var searchService = new window.qq.maps.SearchService({
          pageCapacity: 8,
          complete: function complete(result) {
            var pois = result && result.detail && Array.isArray(result.detail.pois) ? result.detail.pois : [];
            var results = pois.filter(function (poi) {
              return poi.latLng;
            }).map(function (poi) {
              return {
                title: poi.name || keyword,
                address: poi.address || poi.fullname || '',
                lat: poi.latLng.getLat(),
                lng: poi.latLng.getLng()
              };
            });
            resolve(results);
          },
          error: reject
        });
        searchService.search(keyword);
      });
    },
    searchAddressByGeocoder: function searchAddressByGeocoder(keyword) {
      var _this11 = this;
      return new Promise(function (resolve, reject) {
        if (!window.qq || !window.qq.maps || !window.qq.maps.Geocoder) {
          reject(new Error('腾讯地图Geocoder未加载'));
          return;
        }
        var geocoder = new window.qq.maps.Geocoder({
          complete: function complete(result) {
            var detail = result && result.detail ? result.detail : {};
            var location = detail.location;
            if (!location) {
              resolve([]);
              return;
            }
            resolve([{
              title: keyword,
              address: _this11.getGeocoderAddress(result, keyword),
              lat: _this11.getCoordinateValue(location, 'lat', 'getLat'),
              lng: _this11.getCoordinateValue(location, 'lng', 'getLng')
            }]);
          },
          error: reject
        });
        geocoder.getLocation(keyword);
      });
    },
    /**
     * 搜索地址：使用已加载的腾讯地图 JS SDK，避免浏览器直连 WebService 触发 CORS。
     */
    searchAddress: function () {
      var _searchAddress = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee7() {
        var apiKey, keyword, coordinate, results, _t5, _t6;
        return _regenerator().w(function (_context7) {
          while (1) switch (_context7.p = _context7.n) {
            case 0:
              if (this.searchKeyword.trim()) {
                _context7.n = 1;
                break;
              }
              this.$message.warning('请输入搜索关键词');
              return _context7.a(2);
            case 1:
              this.searchLoading = true;
              this.searchResults = [];
              apiKey = this.getCurrentApiKey();
              if (!(!apiKey || apiKey === 'YOUR_TENCENT_MAP_API_KEY')) {
                _context7.n = 2;
                break;
              }
              this.searchLoading = false;
              this.$message.error('请先配置有效的腾讯地图API Key');
              return _context7.a(2);
            case 2:
              _context7.p = 2;
              keyword = this.searchKeyword.trim();
              coordinate = this.parseCoordinateKeyword(keyword);
              if (!coordinate) {
                _context7.n = 4;
                break;
              }
              this.updateMapLocation(coordinate.lat, coordinate.lng);
              this.applyLocationChange(coordinate.lat, coordinate.lng, '');
              _context7.n = 3;
              return this.reverseGeocode(coordinate.lat, coordinate.lng);
            case 3:
              this.closeSearchResults();
              return _context7.a(2);
            case 4:
              results = [];
              if (!(this.mapType === 'TMap')) {
                _context7.n = 6;
                break;
              }
              _context7.n = 5;
              return this.searchAddressByTMapGeocoder(keyword);
            case 5:
              results = _context7.v;
              _context7.n = 10;
              break;
            case 6:
              _context7.p = 6;
              _context7.n = 7;
              return this.searchAddressBySdk(keyword);
            case 7:
              results = _context7.v;
              _context7.n = 10;
              break;
            case 8:
              _context7.p = 8;
              _t5 = _context7.v;
              _context7.n = 9;
              return this.searchAddressByGeocoder(keyword);
            case 9:
              results = _context7.v;
            case 10:
              if (results.length) {
                this.searchResults = results;
                this.showSearchResults = true;
              } else {
                this.$message.warning('未找到相关地址');
              }
              _context7.n = 12;
              break;
            case 11:
              _context7.p = 11;
              _t6 = _context7.v;
              console.error('地址搜索请求失败:', _t6);
              this.$message.error(_t6.message || '搜索服务暂时不可用，请稍后重试');
            case 12:
              _context7.p = 12;
              this.searchLoading = false;
              return _context7.f(12);
            case 13:
              return _context7.a(2);
          }
        }, _callee7, this, [[6, 8], [2, 11, 12, 13]]);
      }));
      function searchAddress() {
        return _searchAddress.apply(this, arguments);
      }
      return searchAddress;
    }(),
    /**
     * 选择搜索结果
     */
    selectSearchResult: function selectSearchResult(result) {
      this.updateMapLocation(result.lat, result.lng);
      this.applyLocationChange(result.lat, result.lng, result.address || '');
      this.reverseGeocode(result.lat, result.lng);
      this.closeSearchResults();
    },
    /**
     * 关闭搜索结果
     */
    closeSearchResults: function closeSearchResults() {
      this.showSearchResults = false;
    },
    /**
     * 隐藏搜索结果
     */
    hideSearchResults: function hideSearchResults() {
      var _this12 = this;
      setTimeout(function () {
        _this12.showSearchResults = false;
      }, 200);
    },
    /**
     * 显示搜索结果（如果存在）
     */
    showSearchResultsIfExists: function showSearchResultsIfExists() {
      if (this.searchResults.length > 0) {
        this.showSearchResults = true;
      }
    }
  }
};